import {
    DatabaseId,
    VerificationStep,
    ViewModel,
    CollectFieldsResponse,
    VerificationStepsEnum,
    PostJson,
    VerificationResponse,
} from '@sheerid/jslib';
import { getFieldsToCollectUrl } from './ApiUrls';

export async function getFieldsToCollect(
    verificationId: DatabaseId,
    step: VerificationStep,
    viewModel: ViewModel,
): Promise<CollectFieldsResponse> {
    if (VerificationStepsEnum[step]) {
        // @ts-expect-error
        const requestBody = stepToRequest[step](viewModel);
        const response = (await PostJson(
            getFieldsToCollectUrl(verificationId, step),
            requestBody,
        )) as VerificationResponse;
        if (response.currentStep === 'error') {
            Promise.reject(new Error(`Failed to determine fields to collect: ${response}`));
        }
        return response as CollectFieldsResponse;
    }
    return Promise.reject(new Error(`Unknown step ${step}`));
}
